import HeaderClient from "./HeaderClient";

/**
 * Site header. The top nav is fixed in code (Services, Products, Resume, Contact)
 * so a CMS navigation document cannot put the old links back.
 */
export default function Header() {
  return <HeaderClient />;
}
